import React, { useState, useEffect } from 'react';
import { Button } from 'antd';
import RtcPlayer from '@/components/VideoPlayer/RtcPlayer';
import './IssueVideo.scss';
import { sendGlobalEvent } from '@/utils/emit';
import { FieldItem } from './WorkOrderCardUI';
import { HttpStatusCode } from '@/fetch/core/constant';
import IssueApi from '@/fetch/bussiness/issue';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import { getClstag } from '@/utils/util';
import { RootState } from '@/redux/store';

const IssueVideo = ({
  magnifyVehicleName,
  vehicleName,
}: {
  magnifyVehicleName: string;
  vehicleName: string;
}) => {
  const fetchApi = new IssueApi();
  const { list } = useSelector((state: any) => state.issue);
  const curIssue = list?.find((v: any) => v.vehicleName === vehicleName);
  const videoDriectionMap = new Map([
    ['front', '前'],
    ['right', '右'],
    ['back', '后'],
    ['left', '左'],
  ]);
  const [curDirection, setCurDirection] = useState<string>('front');
  const [isStop, setIsStop] = useState<boolean>(true);
  const [videoUrlMap, setVideoUrlMap] = useState<Map<string, string>>(
    new Map()
  );
  const [isMagnfied, setIsMagnfied] = useState<boolean>(false);
  const cockpitMode = useSelector(
    (state: RootState) => state.newCommon.cockpitMode
  );
  const getVideoUrl = (direction: string) => {
    return videoUrlMap instanceof Map ? videoUrlMap.get(direction) : undefined;
  };
  useEffect(() => {
    if (curIssue.vehicleName && curIssue.issueType === 'OPS') {
      fetchVideoUrl();
    }
  }, [curIssue.vehicleName]);

  useEffect(() => {
    setIsMagnfied(magnifyVehicleName === curIssue.vehicleName);
  }, [magnifyVehicleName]);

  const fetchVideoUrl = async () => {
    const res = await fetchApi.fetchVideoUrl(curIssue.vehicleName);
    if (res.code === HttpStatusCode.Success) {
      const videoUrl = new Map([
        ['left', res.data.left],
        ['front', res.data.front],
        ['right', res.data.right],
        ['back', res.data.back],
      ]);
      setVideoUrlMap(videoUrl);
    }
  };

  const handleCloseModal = () => {
    sendGlobalEvent('CHANGE_ISSUE_VIDEO_MODAL', {
      open: false,
      videoUrl: '',
      direction: '',
      vehicleName: '',
    });
  };

  const handleOpenModal = () => {
    sendGlobalEvent('CHANGE_ISSUE_VIDEO_MODAL', {
      open: true,
      videoUrl: getVideoUrl(curDirection),
      direction: videoDriectionMap.get(curDirection),
      vehicleName: curIssue.vehicleName,
    });
  };

  const handleChangeDirection = (direction: string) => {
    setCurDirection(direction);
    if (!isStop && magnifyVehicleName) {
      sendGlobalEvent('CHANGE_ISSUE_VIDEO_MODAL', {
        open: true,
        videoUrl: getVideoUrl(direction),
        direction: videoDriectionMap.get(direction),
        vehicleName: curIssue.vehicleName,
      });
    }
  };

  const changeVideoOpenStop = (val: boolean) => {
    setIsStop(val);
    curIssue.vehicleName === magnifyVehicleName &&
      sendGlobalEvent('CHANGE_ISSUE_VIDEO_MODAL', {
        open: false,
        videoUrl: '',
        direction: '',
        vehicleName: curIssue.vehicleName,
      });
  };

  const renderChangeVideo = () => {
    return (
      <div className="issue-video-btn-container">
        <div className="four-way-btn-container">
          {[
            { label: '前', value: 'front' },
            { label: '后', value: 'back' },
            { label: '左', value: 'left' },
            { label: '右', value: 'right' },
          ].map((item) => {
            return (
              <div
                key={item.value}
                className={classNames('four-way-btn', {
                  select: item.value === curDirection,
                })}
                onClick={() => handleChangeDirection(item.value)}
              >
                {item.label}
              </div>
            );
          })}
        </div>
        <div
          className={classNames('', {
            'stop-btn': isStop,
            'play-btn': !isStop,
          })}
          onClick={() => changeVideoOpenStop(!isStop)}
          clstag={
            isStop
              ? getClstag(cockpitMode, 'Card_OpenVideo')
              : getClstag(cockpitMode, 'Card_CloseVideo')
          }
        />
      </div>
    );
  };

  const renderEmpty = () => {
    return (
      <div className="default-message">
        <div>
          <img
            src={require('@/assets/images/cockpit/camera.png')}
            className="camera"
          ></img>
          <div className="camera-notice">视频需要手动开启</div>
          <Button
            className="camera-btn"
            onClick={() => changeVideoOpenStop(false)}
            clstag={getClstag(cockpitMode, 'Card_OpenVideo')}
          >
            开启视频
          </Button>
        </div>
      </div>
    );
  };

  const renderVideo = () => {
    return (
      <>
        {!isMagnfied && (
          <div className="issue-video-box">
            <RtcPlayer
              key={`${curIssue.issueNumber || curIssue.vehicleName}-${curDirection}-${getVideoUrl(curDirection) ?? 'no-url'}`}
              videoUrl={getVideoUrl(curDirection)}
              direction={videoDriectionMap.get(curDirection)!}
            />
            <span className="direction">
              {videoDriectionMap.get(curDirection)}
            </span>
            <div
              className="fbox vbox cbox  glass-box"
              onClick={handleOpenModal}
            >
              <img
                src={require('@/assets/images/cockpit/glass.png')}
                className="glass"
              ></img>
            </div>
          </div>
        )}

        {isMagnfied && (
          <div className="message-tip-area">
            <img
              src={require('@/assets/images/cockpit/camera.png')}
              className="camera"
            ></img>
            <span className="open-msg">
              {videoDriectionMap.get(curDirection)}视频已被放大
            </span>
            <Button className="close-pop-btn" onClick={handleCloseModal}>
              关闭弹窗
            </Button>
          </div>
        )}
      </>
    );
  };

  return (
    <>
      <FieldItem
        label="车辆视频"
        value={renderChangeVideo()}
        key={'renderVideoPic' + curIssue.issueNumber}
      />
      <div className="issue-video-container">
        {isStop ? renderEmpty() : renderVideo()}
      </div>
    </>
  );
};

export default React.memo(IssueVideo);
